export const headerHeightDesktop = 90;
export const headerHeightMobile = 50;
